

import { mapActions, mapState } from 'vuex'
import discounts from '@/components/discountsPopUp/discounts.vue'
import alertone from '@/components/alertbox/alertone'
import bigimgItem from '@/components/bigimg/bigimgItemDetail.vue'
import rest from '@/components/restCart/rest.vue'
import NP from 'number-precision';
import detailSwiper from '@/components/MagicSlider/swiper/detailSwiper'
export default {
  // layout: "notabbar",
  middleware: "header",
  async asyncData ({ error, app, params }) {
    const match = params.id.match(/-(\d+)$/);
    var result
    if (match && match[1]) {
      result = match[1];
    }
    // const g_id = params.id;
    try {
      const { status, data, code } = await app.$api.auyFun.GOODSDETAIL({ goods_id: result });
      console.log(data.data)
      if (status != 200) {
        // return error({ statusCode: 404 });
      } else {
      }
      // bigPic = data.gallery[0].img_url
      return { detailBox: data.data, detailInfo: data.data, goods_id: result };
    } catch (error) {
      console.error(error);

    }
  },
  components: { rest, bigimgItem, alertone, discounts, detailSwiper },
  data: () => ({
    xtwo: ['/img/about/x2_1.png', '/img/about/x2_2.png', '/img/about/x2_3.png', '/img/about/x2_4.png', '/img/about/x2_5.png', '/img/about/x2_6.png'],
    centerDialogVisible: false,
    dialogVisible: false,
    getcuplists: [],
    userInfo: "",
    boxSrcList: [],
    adimg: "",
    bigIndex: 0,
    bigimgBol: false,
    hide_tip_box: {},
    commentList: [],
    img_data: [],
    goods_id: '',
    goods_desc: "",
    detailBox: {},
    detailInfo: {
      store: {
        store_sale_num: 0
      },
      goods_about: [],
      gallery: []
    }, // 商品信息
    appShopId: 0,
    opacity: 1, // 顶部搜索框透明度
    showSpecs: false, // 显示 规格弹窗
    showSpecsType: "all", // 显示弹窗的类型
    word: null,
    fag: 0,
    reFresh: false,
    bigPic: "",
    totalpic: 0,
    totalPage: 0,
    simulated: {},
    xitongtishi: 0,//折叠品论数量
    is_sure: true,//是否可以订阅
    product_number: 0,
    value2: '1',
    ship_fee: {},
    is_reminder: false,//是否订阅
    inputDajian: "",
    FromBottom: false,
  }),
  head () {
    // 优化seo：动态设置title，keywords 和 description
    return {
      title: this.detailInfo.goods_name,
      meta: [
        {
          name: "keywords",
          content:
            this.detailInfo.goods_name,
        },
        // hid是一个唯一标识
        {
          hid: 'description', name: 'names', content: this.detailInfo.goods_name
        },
      ],
    };
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll1);
  },
  mounted () {

    if (process.client) {
      console.log(this.detailInfo.shipping_da, this.detailInfo.is_oversea)
      window.addEventListener("scroll", this.handleScroll1);
      this.goodsDetail()
      this.getCommentList(1)
      this.getcuplist()
      this.getShipPee()
      this.userInfo = JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')) : {}
      this.detailBox = this.detailInfo
      // this.bigPic = this.detailInfo.gallery[0].img_url
      this.cat_id = this.detailBox.cat_id
      this.inputDajian = this.detailBox.user_email
      this.overweight_pop_txt = this.detailBox.overweight_pop_txt
      this.boxinner = true
      if (this.detailBox.is_wholesale == 1) {
        self.$customJump({
          path: '/content/detailFa',
          query: { goods_id: this.detailBox.goods_id }
        })
      }
      // this.appShopId = this.detailBox.store.txim_id

      if (this.detailBox.default_address) {
        // self.ship_fee = res.data.default_address.ship_fee
        this.country_name = this.detailBox.default_address.consignee + "," + this.detailBox.default_address.city_name + "," + this.detailBox.default_address.post_code
        this.countryid = this.detailBox.default_address.country
        this.address_id = this.detailBox.default_address.address_id
      }
      this.market_price = this.detailBox.market_price
      this.shop_price = this.detailBox.shop_price
      this.bigsrc = this.detailBox.goods_video
      if (this.detailBox.goods_video) {
        this.playerFun = true
      }
      this.bigPic = this.detailBox.gallery[0].img_url
      if (this.detailBox.format.length != 0) {
        this.detailBox.format.forEach((j, k) => {
          j.attr_value.forEach((j1, k1) => {
            j1.is_select = 1
          })
        })
      }
      if (this.detailBox.product_list.length == 0) {
        this.product_id = 0
        this.product_number = this.detailBox.goods_number
        if (this.detailBox.goods_number == 0) {
          this.is_sure = false
        } else {
          this.is_sure = true
        }

        if (this.detailBox.is_reminder == 0) {
          this.is_reminder = false
        } else {
          this.is_reminder = true
        }
      } else {
        this.detailBox.product_list.forEach((v) => {
          v.goods_attr = v.goods_attr.split('|')
          v.goods_attr = v.goods_attr.join()
        })
        this.simulated = this.detailBox
        this.simulated.difference = this.detailBox.product_list
        this.detailBox.format.forEach((j, k) => {
          j.show_name = ''
        })
        this.simulated.specifications = this.detailBox.format
      }
    }

    // 监听滚动
    // this.$nextTick(() => {
    //   this.$refs["container"].addEventListener("scroll", this.containerScroll);
    // });
  },
  methods: {
    ...mapActions('shopCart', ['CEATEORDER', 'SETTYPE', 'SETCAROBJ']),
    ...mapActions('loginInfo', ['SETLOGIN', 'SETACTIVE']),
    //到货提醒
    async arrica (g) {
      var self = this
      if (self.is_reminder) {
        self.subcansel()
      } else {
        self.goodsDajian(2)
      }
    },
    async subcansel () {
      let self = this
      let objInfo = {
        goods_ids: self.goods_id,
        type: 2,
        product_id: self.detailInfo.product_list.length == 0 ? 0 : self.product_id,
      }
      let { data, code, msg } = await auyFun.SUBSCRCANSEL(objInfo)
      if (code == 200) {
        if (data.is_reminder == 0) {
          self.is_reminder = false
        } else {
          self.is_reminder = true
        }
      }
    },
    //大件提交
    goodsDajian (k) {
      if (localStorage.getItem('userInfo')) {
        var _this = this
        this.$prompt(`<div class="custom-div">${_this.overweight_pop_txt[0]}</div><div class="custom-div">${_this.overweight_pop_txt[1]}</div>`, 'Confirm your email', {
          confirmButtonText: 'Confirm',
          dangerouslyUseHTMLString: true,
          inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
          inputErrorMessage: 'The email format was entered incorrectly.',
          inputValue: _this.inputDajian,
          showCancelButton: false,
          lockScroll: false,
          confirmButtonClass: "tiancai"
        }).then(({ value }) => {
          let emi
          if (value) {
            emi = value
          } else {
            emi = _this.inputDajian
          }
          _this.dajianOpen(emi, k)
        }).catch(() => {

        });
      } else {
        this.SETACTIVE(true)
        // this.$customJump({
        //   path: '/content/login',
        //   query: { redirect: this.$router.currentRoute.fullPath }
        // })
      }
    },
    async dajianOpen (j, k) {
      var self = this
      var orderInfo = {
        goods_id: self.goods_id,
        user_email: j,
        type: k,
        product_id: self.detailInfo.product_list.length == 0 ? 0 : self.product_id,
      }
      let { data, code, msg } = await self.$api.auyFun.SUBSCRADD(orderInfo)
      if (data.code == 200) {
        if (data.data.is_reminder == 0) {
          self.is_reminder = false
        } else {
          self.is_reminder = true
        }
        self.inputDajian = j
        self.$message.success(data.msg)
        // self.tapColl()
        // self.detailInfo.is_collect = 1
      } else {
        self.$message.info(data.msg)
      }
    },
    showAlert () {
      this.addressList()
    },
    addressList () {
      this.address = []
      this.ad_active = 999
      var _this = this
      // 获取用户地址
      _this.$axios({
        url: "/pc/address/list",
        method: 'get'
      }).then((res) => {
        if (res) {
          if (res.data) {
            res.data.forEach((j, k) => {
              if (j.is_select == 1) {
                _this.ad_active = k
              }
            })
          }
          _this.address = res.data
          if (_this.address.length != 0) {
            _this.$refs['screenChild'].check()
          } else {
            _this.$refs['screenChild1'].check()
          }
        }
      })
    },
    async getcuplist () {
      let params = {
        suppliers_id: this.detailInfo.suppliers_id,
        goods_id: this.goods_id,
        is_page: 0
      }
      let { data, code, msg } = await this.$api.auyFun.GETCUPLIST(params)
      if (data.code != 200) {
      } else {
        // data.forEach((j, k) => {
        //   j.use_end_time = this.formato(j.use_end_time)
        // })
        this.getcuplists = data.data
      }
    },
    //收藏
    async tapColl (k, j) {
      debugger
      var self = this
      var orderInfo = {
        goods_id: self.goods_id,
        type: 1
        // type: k,
        // status: j
      }
      if (self.detailInfo.is_collect == 0) {
        let { data, code, msg } = await self.$api.auyFun.SUBSCRADD(orderInfo)
        if (data.code == 200) {
          self.detailInfo.is_collect = 1
        }
      } else {
        let arr = []
        arr.push(self.goods_id)
        var orderInfo = {
          goods_ids: arr
        }
        let { data, code, msg } = await self.$api.auyFun.SUBSCRADD(orderInfo)
        if (data.code == 200) {
          self.detailInfo.is_collect = 0

          // if (self.detailInfo.is_collect == 1) {
          // 	self.detailInfo.is_collect = 0
          // } else {
          // 	self.detailInfo.is_collect = 1
          // }
        }
      }
    },
    bigimgBoladmin (list, bigIndex, adimg) {
      this.bigimgBol = true
      this.boxSrcList = list
      this.bigIndex = bigIndex
      this.adimg = adimg
    },
    //影藏评价
    async gethidelist () {
      if (this.hide_tip_box.hide_click != 0) {
        var self = this
        let orderInfo = {
          pz: self.hide_tip_box.hide_count ? self.hide_tip_box.hide_count : "10",
          goods_id: self.goods_id,
        }
        let { data, code, msg } = await self.$api.auyFun.HIDDENLIST(orderInfo)
        if (data.code == 200) {
          self.hidedialogVisible = true
          self.hideListbox = data.data.data
        }
      }

    },
    pageChage (k) {
      this.getCommentList(k)
    },
    //评价
    getCommentList (k) {

      var _this = this
      let params = {
        goods_id: _this.goods_id,
        page: k,
        pageSize: 5
      }
      _this.$axios({
        url: "/pc/getCommentList",
        method: 'get',
        params: params
      })
        .then((res) => {
          if (res.code == 200) {
            // res.data.data.forEach((j, k) => {
            // 	j.active = false

            // })
            // j.add_time = this.getNowDate(j.add_time)
            _this.commentList = res.data.data
            _this.img_data = res.data.img_data
            _this.hide_tip_box = res.data
            if (res.data.data.length < 5 || res.data.total <= 5 || res.data.last_page == k) {
              _this.xitongtishi = NP.minus(_this.detailInfo.score_total, res.data.total)
            }
            // _this.totalPage = (res.data.total + 5 - 1) / 5
            _this.totalPage = res.data.last_page
            _this.totalpic = res.data.total
          }
        })
    },
    goodsDetail () {

      var self = this
      var data = {
        goods_id: this.goods_id
      }
      //   data = fly.initData(data);
      this.$axios({
        url: "/pc/goods/goodsDetail",
        method: 'get',
        params: data
      })
        .then((res) => {

          if (res.code == 200) {

            self.goods_desc = res.data.goods_desc
          }
        })
        .catch((e) => {
          console.info(e)
        })
    },
    updateColor () {
      this.product_id = ''
      this.detailInfo.market_price = this.market_price
      this.detailInfo.shop_price = this.shop_price
    },
    //选择sku
    updatePrice (data) {
      this.detailInfo.market_price = data.market_price
      this.detailInfo.shop_price = data.shop_price
      this.product_id = data.product_id
      if (data.attr_img) {
        this.bigPic = data.attr_img
      }
      let orderInfo = {
        country_id: this.countryid,
        goods_id: this.goods_id,
        product_id: this.product_id ? this.product_id : 0
      }

      this.getShipPee(orderInfo)
      this.getsku(data.selectArr)
    },
    async getShipPee (orderInfo) {
      if (orderInfo) {
        var objInfo = {
          goods_id: orderInfo.goods_id,
          num: this.value2,
          product_id: orderInfo.product_id,
        }
      } else {
        var objInfo = {
          goods_id: this.goods_id,
          num: this.value2,
          product_id: this.product_id,
        }
      }

      let { data, code, msg } = await this.$api.auyFun.GETSHIPFEE(objInfo)
      if (data.code != 200) {
        // this.$message.warning(msg)
      } else {
        this.ship_fee = data.data
      }
    },
    async getsku (k) {
      let objInfo = {
        goods_attr_id: k,
        goods_id: this.goods_id
      }
      var _this = this
      let { data, code, msg } = await _this.$api.auyFun.GETSKU(objInfo)
      if (data.code == 200) {
        var kk = k.join(",")
        if (_this.value2 > data.data[0].product_number) {
          _this.value2 = data.data[0].product_number
        }
        _this.product_number = data.data[0].product_number
        data.data.forEach((j, k) => {
          if (kk == j.goods_attr) {
            //判断是否有库存
            if (j.product_number == 0) {

              _this.is_sure = false
            } else {
              _this.is_sure = true
            }
            if (j.is_reminder == 0) {
              _this.is_reminder = false
            } else {
              _this.is_reminder = true
            }

          }
        })
      }
    },
    mouseOver (j, k) {
      // if (j.video_url) {
      //   this.playerFun = true
      // } else {
      //   this.playerFun = false
      // }
      this.bigPic = j.img_url
      this.fag = k
      // this.swiperId = k
      // this.$set(this, "bigPic", j.img_url);
    },
    handleChange (value) {
    },
    toAddress () {
      debugger
      if (this.detailInfo.is_member_goods == 1) {
        this.$customJump({
          path: '/content/FactoryMember'
        })
      } else {
        this.toAddress1()
      }
    },
    async Helpful (g) {
      var self = this
      let orderInfo = {
        goods_id: self.goods_id,
        comment_id: g.comment_id
      }
      let { data, code, msg } = await auyFun.ADDCOMMENT(orderInfo)
      if (code == 200) {
        self.commentList.forEach((j, k) => {
          if (j.comment_id == g.comment_id) {
            j.active = true
          }
        })
        self.$forceUpdate() //重绘
      }
    },
    toAddress1 () {
      debugger
      if (this.detailInfo.product_list.length == 0 || this.product_id != '') {
        var orderInfo = {
          goods_id: this.goods_id,
          goods_num: this.value2,
          address_id: this.address_id,
          product_id: this.detailInfo.product_list.length == 0 ? 0 : this.product_id,
          suppliers_id: this.detailInfo.suppliers_id
        }
        if (this.address_id == "") {
          this.$customJump({
            path: '/content/address/1'
          })
        } else {
          this.CEATEORDER(orderInfo)
          this.SETTYPE('1')
          this.$customJump({
            // path: `/payment?address_id=${this.address_id}`
            path: `/content/payment`
          })
        }

      } else {
        this.$message.warning('Please select the specification first')
      }
    },
    //售后提示
    shouhou (k, j) {
      var _this = this
      this.$alert("<img src=" + _this.detailInfo.refund_img + ">", 'Returns/ refund policy', {
        center: true,
        dangerouslyUseHTMLString: true,
        showCancelButton: false,
        showConfirmButton: false
      }).then(({ }) => {

      }).catch(() => {
      });

    },
    //售后提示
    shouhou1 (k, j) {
      this.centerDialogVisible = true

    },
    toCart () {
      if (this.detailInfo.product_list.length == 0 || this.product_id != '') {
        var orderInfo = {
          goods_id: this.goods_id,
          goods_num: this.value2,
          address_id: this.address_id,
          product_id: this.detailInfo.product_list.length == 0 ? 0 : this.product_id,
          suppliers_id: this.detailInfo.suppliers_id
        }

        this.CEATEORDER(orderInfo)
        this.SETTYPE('1')

        this.addCart(orderInfo)

      } else {
        this.$message.warning('Please select the specification first')
      }
    },
    //去购物车
    async addCart (orderInfo) {
      // let objInfo = {
      // 	goods_id: this.orderInfo.goods_id,
      // 	goods_num: this.orderInfo.goods_num,
      // 	product_id: this.orderInfo.product_id,
      // 	suppliers_id: this.orderInfo.suppliers_id
      // }
      let { data, code, msg } = await this.$api.auyFun.GET_ADDCART(orderInfo)

      if (data.code != 200) {
        this.$message.warning(data.msg)
      } else {

        // fbq('track', 'AddToCart', {
        //   content_ids: [orderInfo.goods_id],
        //   contents: [
        //     { 'id': orderInfo.goods_id, 'quantity': orderInfo.goods_num },

        //   ],
        //   content_type: 'product',
        //   value: data.data.shop_price,
        //   currency: 'USD'
        // })
        ttq.track('AddToCart')





        let datobj = {
          goods_id: orderInfo.goods_id,
          goods_num: orderInfo.goods_num,
          product_id: orderInfo.product_id,
          suppliers_id: orderInfo.suppliers_id,
          cart_id: data.data.cart_id
        }
        // this.mailchimpadd(orderInfo.goods_id, orderInfo.goods_num, orderInfo.product_id, orderInfo.suppliers_id, data.cart_id)
        this.mataStatistics(datobj)



        this.$customJump({
          path: '/content/shopCart',
          query: { num: data.data.goods_num, price: data.data.shop_price }
        })
        this.SETCAROBJ(data.data)
      }
    },
    mataStatistics (datobj) {

      if (localStorage.getItem('userInfo')) {
        var self = this
        let em = self.$sha256(this.userInfo.email)
        let ph = self.$sha256(this.userInfo.mobile_phone)
        let userAgent = navigator.userAgent;
        let clientIpAddress = self.userInfo.ip;
        let timestamp = Math.floor(new Date().getTime() / 1000)
        self.$axios({
          method: "post",
          url: "https://graph.facebook.com/v17.0/832685061480710/events?access_token=EAAYolWRudJgBO69UKBuKqn9GqCsXpP3ccQYbn2l4IDiuGMTc7ZB4qZBxP68nZAAngeRS1dkfSpOuYVt3H3OYXVb2xI6apQF6ZCmZBNxdYZAQ7tPHcdoz0lar0uZAyZALqXA3geb5xKFYMMhunrMg1R421v8CGkKbLLNVrBGM1mZCNtPnPtZCVB0J45TXrddQu2chFPXAZDZD",
          data: {
            "data": [
              {
                "event_name": "AddToCart",
                "event_time": timestamp,
                "action_source": "website",
                "event_id": datobj.cart_id,
                "user_data": {
                  "em": em,
                  "ph": ph,
                  // "client_ip_address": "254.254.254.254", "client_user_agent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64; rv:63.0) Gecko/20100101 Firefox/63.0"
                  "client_ip_address": clientIpAddress,
                  "client_user_agent": userAgent
                },
                "custom_data": {
                  "content_ids": datobj.goods_id,
                  "content_num": datobj.goods_num,
                  "content_product_id": datobj.product_id,
                  "content_suppliers_id": datobj.suppliers_id
                }
              },
            ],
            "test_event_code": self.$TESTCODE
          },
        }).then((res) => {
          console.log(res.data);
        })
      }
    },
    toLink () {
      // this.$customJump({
      //   path: '/shop',
      //   query: {
      //     store: this.detailInfo.suppliers_id
      //   }
      // })
      this.$customJump({
        path: '/content/stores',
        query: {
          store: this.detailInfo.suppliers_id
        }
      })
    },
    // 搜索自动跳转搜索页
    onSearch (word) {
      this.$customJump({
        path: "/content/search",
        query: {
          word
        }
      });
    },
    // 监听页面滚动
    handleScroll1 () {
      // 获取当前的滚动距离
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;
      const documentHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      const distanceFromBottom = documentHeight - (scrollTop + windowHeight);
      console.log(distanceFromBottom)
      if (distanceFromBottom < 290) {
        this.FromBottom = true
        console.log('接近底部');
      } else if (distanceFromBottom < 9000) {
        this.FromBottom = false
        console.log('离开底部');
      }
      // 判断滚动条向上还是向下滚动
      if (window.scrollY > this.previousScroll) {
        this.opacity = 0
      } else {
        this.opacity = 1
        // console.log('向上滚动');
      }
      this.previousScroll = window.scrollY;
    },
    // 设置搜索框透明度
    // containerScroll (e) {
    //   const top = this.$refs["container"].scrollTop;
    //   const opacity = top / 300;
    //   if (opacity <= 1.5) {
    //     this.opacity = opacity;
    //   }
    // },
    openGoodsSpecsPop (isShow, type) {
      this.showSpecs = isShow;
      this.showSpecsType = type;
    },
    // 跳转 订单页面
    goOrder (data) {
      const goodsInfo = { ...this.info, ...data };
      this.$customJump({
        path: "/content/order-stay",
        params: { type: "goods", goodsInfo }
      });
    },
    // 点击 收藏
    clickLike () {
      const fn = this.info.isLike ? this.$apiDelLike : this.$apiAddLike;
      const { g_id } = this.info;
      fn({ g_id }).then(res => {
        if (res.status === 0) {
          this.$toast({ message: res.msg });
          this.info.isLike = res.data;
        }
      });
    }
  },
  computed: {
    // 图片轮播数组
    imgs () {
      if (!this.info.g_src) {
        return [];
      }
      return this.info.g_src.split(",");
    },
    // 购买人数
    buynum () {
      if (!this.info.specs || !Array.isArray(this.info.specs)) {
        return 0;
      }
      return this.info.specs.reduce((a, c) => a + c.buy_num, 0);
    },
    // 显示价格
    price () {
      if (!this.info.specs || !Array.isArray(this.info.specs)) {
        return 0;
      }
      let price = [],
        discountedPrice = [];
      this.info.specs.forEach(s => {
        if (s.discounted_price) {
          discountedPrice.push(s.discounted_price);
        } else {
          price.push(s.sell_price);
        }
      });
      const all = price.concat(discountedPrice);
      if (all.length === 0) {
        return this.info.discounted_price || this.info.sell_price;
      }
      if (all.length === 1) {
        return all[0];
      }
      all.sort((a, b) => a - b);
      if (all[0] === all[all.length - 1]) {
        return all[0];
      }
      return `${all[0]}~${all[all.length - 1]}`;
    }
  },

  // 卸载解除 监听
  beforeDestroy () {
    // this.$refs["container"].removeEventListener("scroll", this.containerScroll);
  }
};
